import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class VerticalScroll {
  static pinSwiper(slider, swiperInstance) {
    const swiper = swiperInstance

    gsap.to(swiper.slides, {
      yPercent: -((swiper.slides.length / 3 - 1) * 100),
      ease: 'none',
      scrollTrigger: {
        trigger: '.swiper--vertical-scroll',
        start: 'top-=10 top',
        end: () => `+=${swiper.slides.length * (window.innerHeight / 3)}`,
        pin: true,
        scrub: true,
        onUpdate: (self) => {
          let progress = self.progress * (swiper.slides.length);
          swiper.slideTo(Math.round(progress), 300, false)
        },
        id: 'VerticalScroll',
        markers: false,
      },
    })
  }
}